<template>
  <div class="overview">
    <el-card class="box-card">
      <div
        slot="header"
        class="hearder"
      >
        <span>导购业绩</span>
      </div>
      <div>
        <el-row v-if="overviewData.salesperson">
          <el-col :span="8">
            <div>
              <span class="table-title">今日实时</span>
              <span
                class="table-header-tips"
              >更新时间：{{ overviewData.salesperson.last_time }}</span>
            </div>
            <div class="count">
              <span>￥</span>{{ overviewData.salesperson.today / 100 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="table-title">
              昨日业绩
            </div>
            <div class="count">
              <span>￥</span>{{ overviewData.salesperson.yesterday / 100 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="table-title">
              本月累计
            </div>
            <div class="count">
              <span>￥</span>{{ overviewData.salesperson.this_month / 100 }}
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-card class="box-card">
      <div
        slot="header"
        class="hearder"
      >
        <span>编外业绩</span>
      </div>

      <el-table
        :data="overviewData.operator"
        style="width: 100%"
        class="overview-table"
      >
        <el-table-column
          prop="store_name"
          label="编外渠道"
        />

        <el-table-column>
          <template #header>
            <span class="table-title">今日实时</span>
            <span
              class="table-header-tips"
            >更新时间：{{ overviewData.salesperson.last_time }}</span>
          </template>
          <el-table-column label="绑定导购业绩">
            <template slot-scope="scope">
              <span><span class="money">￥</span>{{ scope.row.today.operate_bind / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="渠道专属业绩">
            <template slot-scope="scope">
              <span><span class="money">￥</span>{{ scope.row.today.operate_sales / 100 }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column>
          <template slot="header">
            <span class="table-title">昨日业绩</span>
          </template>
          <el-table-column label="绑定导购业绩">
            <template slot-scope="scope">
              <span><span class="money">￥</span>{{ scope.row.yesterday.operate_bind / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="渠道专属业绩">
            <template slot-scope="scope">
              <span><span class="money">￥</span>{{ scope.row.yesterday.operate_sales / 100 }}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column>
          <template slot="header">
            <span class="table-title">本月累计</span>
          </template>
          <el-table-column label="绑定导购业绩">
            <template slot-scope="scope">
              <span><span class="money">￥</span>{{ +scope.row.this_month.operate_bind / 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="渠道专属业绩">
            <template slot-scope="scope">
              <span><span class="money">￥</span>{{ +scope.row.this_month.operate_sales / 100 }}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    overviewData: {
      type: Object
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.overview {
  .hearder {
    font-size: 20px;
    color: rgba(96, 98, 102, 0.698039215686274);
  }

  .count {
    font-family: 'Helvetica';
    font-weight: 400;
    font-style: normal;
    font-size: 24px;
    color: #606266;
    margin-top: 10px;
    span {
      font-size: 14px;
    }
  }
  .money {
    font-size: 8px;
  }

  .table-header-tips {
    color: rgba(51, 51, 51, 0.305882352941176);
    font-size: 13px;
    margin-left: 10px;
  }
  .table-title {
    font-family: 'PingFangSC-Regular', 'PingFang SC';
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    color: rgba(96, 98, 102, 0.698039215686274);
  }

  ::v-deep {
    .el-card__header {
      border-bottom: 1px solid #ebeef5;
    }
    .el-table--border,
    .el-table--group {
      border: none;
    }

    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      content: '';
      position: absolute;
      background-color: #fff;
      z-index: 1;
    }

    .is-leaf {
      .cell {
        color: rgba(96, 98, 102, 0.698039215686274);
        font-size: 14px;
        font-weight: 400;
        font-family: 'PingFangSC-Regular', 'PingFang SC';
      }
    }

    .el-table_1_column_1.is-leaf .cell {
      font-family: 'PingFangSC-Regular', 'PingFang SC';
      font-weight: 400;
      font-style: normal;
      font-size: 16px;
      color: rgba(96, 98, 102, 0.698039215686274);
    }
  }
}
.el-card {
  margin-bottom: 20px;
}
</style>
